import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { routes } from './app.routing';
import { ConfirmationService } from 'primeng/api';
import { AuthService } from './services/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { IsActiveFilter, IsPublishedFilter, NameFilter } from './pages/flow-definition-list/flow-definition-list.pipe';
import { CatalogServicesFilter } from './components/details/flow-definition/default/fdd-default.pipe';
import { PlanosFilter, ClassesFilter, FundamentosFilter, PatriarcasFilter, OrganizacoesFilter, UnidadesFilter, GruposFilter, ComissoesFilter, PapeisFilter } from './components/details/flow-object/default/fod-default.pipe';
import { authInterceptor } from './core/http/auth.interceptor';
import { TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        provideAnimations(),
        provideHttpClient(withInterceptors([authInterceptor])),

        importProvidersFrom(
            ToastrModule.forRoot({
                timeOut: 5000,
                extendedTimeOut: 5000,
                positionClass: 'toast-top-right',
                preventDuplicates: true,
                enableHtml: true,
                progressBar: true,
                progressAnimation: 'increasing'
            })
        ),

        { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },

        ConfirmationService,
        AuthService,
        CookieService,
        NameFilter,
        IsActiveFilter,
        IsPublishedFilter,
        PlanosFilter,
        ClassesFilter,
        FundamentosFilter,
        PatriarcasFilter,
        OrganizacoesFilter,
        UnidadesFilter,
        GruposFilter,
        ComissoesFilter,
        PapeisFilter,
        CatalogServicesFilter
    ]
};
